import { Prefetch } from './components/Prefetch';
import { Provider } from './context';
import { useRequestsLoaderState } from './hooks';

import type { FC, PropsWithChildren as PrefetchProviderProps } from 'react';

export const PrefetchProvider: FC<PrefetchProviderProps> = props => {
  const requestsLoaderState = useRequestsLoaderState();

  return (
    <Provider value={requestsLoaderState}>
      <Prefetch {...props} />
    </Provider>
  );
};
